/**
 * PostgREST search helpers.
 *
 * A user-typed term is interpolated into PostgREST's `.or()` filter grammar,
 * which is comma/parenthesis delimited. Unescaped `,` `(` `)` `.` `"` `*` `\`
 * in the term either break the filter or let the user inject extra predicates,
 * so they are stripped before composition (see feedback_postgrest_or_sanitize).
 *
 * This mirrors the local `sanitizeSearch` already used by
 * `components/sales-activities/PhoneSaleForm.tsx` and the server-side
 * `regexp_replace(v_term, '[,()."*\\]', '', 'g')` in the `search_contacts_page`
 * RPC, so all three agree on what a "safe" term looks like.
 */
export const sanitizePostgrestSearchTerm = (term: string): string =>
  term.replace(/[,()."*\\]/g, "").trim();

/**
 * Like sanitizePostgrestSearchTerm, but for an `ilike` term: each reserved character becomes `_`
 * (LIKE's "any one character") instead of being dropped, so "J.D. Smith" or "Smith, Inc." still
 * match the stored name. `%` (LIKE wildcard) and `:` (PostgREST reserved) are mapped too, so the
 * result can never break the `.or()` grammar or add a predicate. Capped at 100 characters.
 */
export const postgrestIlikeTerm = (term: string): string =>
  term
    .trim()
    .slice(0, 100)
    .replace(/[,()."*\\%:]/g, "_")
    .trim();
